export const ru = {
    '0-17': 'младше 18',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': 'старше 55',
    'all-ages': 'всех возрастов',
    'all-genders': 'Мужчины и женщины',
    'all-items': 'Все',
    'all-mobile': 'Все смартфоны',
    android: 'Android',
    cancel: 'Отмена',
    'closed-panel-description':
        'Корректировки ставок позволяют повысить или понизить ставку в зависимости от характеристик пользователя, формата объявления и даже фактической погоды.',
    'demography-tab': 'Пол и возраст',
    desktops: 'Десктопы',
    'device-tab': 'Устройства',
    female: 'Женщины',
    'hide-full-value': 'Скрыть все условия',
    ios: 'iOS',
    male: 'Мужчины',
    mobile: 'Смартфоны',
    'mobile-tab': 'Устройства',
    'more-info-link': 'Подробнее',
    'no-value': 'Задайте корректировки ставок, чтобы получить больше трафика',
    'opened-panel-description':
        'Ставку можно повысить или понизить с помощью коэффициентов. Коэффициент — это заданная в процентах величина, на которую изменяется ставка. Если корректировок несколько, они применяются последовательно. {moreInfoLink}',
    'other-devices': 'Другие устройства',
    'panel-description':
        'Ставку можно повысить или понизить с помощью коэффициентов. Коэффициент — это заданная в процентах величина, на которую изменяется ставка. Если корректировок несколько, они применяются последовательно. {moreInfoLink}',
    ready: 'Готово',
    'retargeting-tab': 'Целевая аудитория',
    'show-full-value': 'Показать все условия',
    'smart-banners-tab': 'Смарт-объявления',
    tablets: 'Планшеты',
    title: 'Корректировки ставок',
    'video-addition-tab': 'Видеодополнения',
    'weather-tab': 'Погода'
};
